import Price from '@/components/money/price'
import { type SurchargePayments, type Surcharges } from '@/api/accommodation/types'

interface SurchargesCardProps {
  surcharges: Surcharges
  surchargePayments: SurchargePayments
}

function SurchargesCard({ surcharges, surchargePayments }: SurchargesCardProps) {
  return (
    <div className="flex grow flex-col gap-2">
      <div className="">Příplatky mimo cenu hrazeny na místě:</div>
      <div>
        {surcharges.map((surcharge, index) => (
          <div key={index} className="flex justify-between">
            <span>{surcharge.type}</span>
            <div className="space-x-1">
              <Price price={surcharge.price} className="font-medium" />
              <span>/</span>
              <span>{surcharge.unit}</span>
            </div>
          </div>
        ))}
      </div>

      {surchargePayments.length > 0 && (
        <div className="mt-2 flex justify-between">
          <span>Způsob úhrady: </span>
          <span className="font-medium">{surchargePayments.map((payment) => payment.name).join(', ')}</span>
        </div>
      )}
    </div>
  )
}

export default SurchargesCard
